module.exports = __webpack_public_path__ + "static/media/home-hisopado.a5c3bfe5.png";